// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3bZKa","header":"MergedInvoice_header__Fmz_R"};